import { render, staticRenderFns } from "./pageMix.vue?vue&type=template&id=52ab02b3"
import script from "./pageMix.vue?vue&type=script&lang=js"
export * from "./pageMix.vue?vue&type=script&lang=js"
import style0 from "./pageMix.vue?vue&type=style&index=0&id=52ab02b3&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports